const compareKey = 'compareProducts';

  // --- Shared functions ---
  function getCompareList() {
    const stored = localStorage.getItem(compareKey);
    return stored ? JSON.parse(stored) : [];
  }
  
  function saveCompareList(list) {
    localStorage.setItem(compareKey, JSON.stringify(list));
  }
  
  function updateCompareButtonVisibility() {
    const compareList = getCompareList();
    const wrapper = document.getElementById('view-compare-wrapper');
    const count = document.getElementById('compare-count');

    if (compareList.length > 0) {
      wrapper && (wrapper.style.display = 'flex');
      count && (count.textContent = compareList.length);
    } else {
      wrapper && (wrapper.style.display = 'none');
      count && (count.textContent = '0');
    }
  }
  
  // --- Get references outside DOMContentLoaded so they can be used globally ---
  const bar = document.getElementById('compare-bar');
  const container = bar?.querySelector('.compare-bar__products');
  const clearBtn = document.getElementById('clear-compare-bar');
  const compareBtn = document.getElementById('compare-now-button');
  
  // --- Global function: loadCompareBar ---
  function loadCompareBar() {
    const compareItems = getCompareList();
  
    if (!bar || !container) return;
  
    if (!compareItems.length) {
      bar.style.display = 'none';
      return;
    }
  
    bar.style.display = 'block';
    container.innerHTML = '';
  
    compareItems.forEach(product => {
      const item = document.createElement('div');
      item.className = 'compare-item';
      item.innerHTML = `
        <div class="compare-bar-item">
          <span>${product.title}</span>
          <button data-id="${product.handle}" class="remove-compare-item">×</button>
        </div>
        <img src="${product.image}" class="compare-bar-img" alt="${product.title}">
      `;

      container.appendChild(item);
    });
  
    compareBtn?.classList.toggle('disabled', compareItems.length === 0);
  }
  
  // --- Checkbox logic ---
  document.addEventListener('DOMContentLoaded', () => {
    updateCompareButtonVisibility();
  
    document.querySelectorAll('.compare-checkbox').forEach(checkbox => {
      checkbox.addEventListener('change', function () {
        let compareList = getCompareList();
  
        const handle = checkbox.dataset.productHandle || checkbox.dataset.handle;
        const title = checkbox.dataset.productTitle || 'No Title';
        const image = checkbox.dataset.productImage || '';
  
        console.log('[Compare] Checkbox clicked');
        console.log('[Compare] Product handle:', handle);
        console.log('[Compare] Product title:', title);
        console.log('[Compare] Product image:', image);
  
        if (checkbox.checked && !compareList.find(p => p.handle === handle)) {
          compareList.push({ handle, title, image });
        } else if (!checkbox.checked) {
          compareList = compareList.filter(p => p.handle !== handle);
        }
  
        saveCompareList(compareList);
        updateCompareButtonVisibility();
        loadCompareBar(); // Instant update without reload
      });
    });
  
    // Initial bar render
    loadCompareBar();
  });
  
  // --- Remove and Clear Buttons ---
  document.body.addEventListener('click', function (e) {
    if (e.target.classList.contains('remove-compare-item')) {
      const id = e.target.dataset.id;
      let items = getCompareList().filter(p => p.handle !== id);
      saveCompareList(items);
      loadCompareBar();
      updateCompareButtonVisibility();

      // ✅ Uncheck any checkbox on the page with that handle
      document.querySelectorAll(`.compare-checkbox[data-handle="${id}"]`).forEach(cb => {
        cb.checked = false;
      });
    }
  });

  
  clearBtn?.addEventListener('click', () => {
    localStorage.removeItem(compareKey);
    loadCompareBar();
    updateCompareButtonVisibility();

    // ✅ Uncheck all compare-checkboxes on the page
    document.querySelectorAll('.compare-checkbox').forEach(cb => {
      cb.checked = false;
    });
  });

  document.getElementById('clear-compare-mobile')?.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    localStorage.removeItem(compareKey);
    loadCompareBar();
    updateCompareButtonVisibility();

    document.querySelectorAll('.compare-checkbox').forEach(cb => {
      cb.checked = false;
    });
  });

  // Attach event handler to Compare Now button
  document.addEventListener('DOMContentLoaded', function () {
    document.getElementById('compare-now-button')?.addEventListener('click', function (e) {
      e.preventDefault(); // stop navigation
      openCompareModal(); // open the modal instead
    });
  });

  // --- Modal logic ---
  window.openCompareModal = async function () {
    const compareList = getCompareList();
    const modalContent = document.getElementById('compare-modal-content');

    if (!modalContent) return;

    if (compareList.length === 0) {
      modalContent.innerHTML = '<p>No products selected for comparison.</p>';
      const modal = document.getElementById('compare-modal');
      modal.style.display = 'block';
      attachOutsideClickToModal();

      return;
    }

    modalContent.innerHTML = '<p>Loading comparison...</p>';
    const modal = document.getElementById('compare-modal');
    modal.style.display = 'block';
    attachOutsideClickToModal();


    try {
      const yesIcon = 'https://cdn.shopify.com/s/files/1/0743/0576/5609/files/tick-only.png?v=1749982281';
      const noIcon = 'https://cdn.shopify.com/s/files/1/0743/0576/5609/files/stop-icon.png?v=1749809059';

      const features = [
        { key: '250V_insulation', label: '250V Insulation', tooltip: 'Used on sensitive equipment to avoid damage from 500V tests.' },
        { key: '500V_insulation', label: '500V Insulation', tooltip: 'Standard voltage used to test insulation integrity.' },
        { key: '10A_operation', label: '>10A Operation', tooltip: 'Required for testing appliances drawing more than 10 amps.' },
        { key: 'isolation_transformer', label: 'Isolation Transformer', tooltip: 'Prevents RCD tripping during portable RCD testing.' },
        { key: 'RCD_testing', label: 'RCD Testing', tooltip: 'Ensures safety switches cut power in fault conditions.' },
        { key: '3PH_testing', label: '3PH Testing (Adaptor)', tooltip: 'Allows testing of 3-phase appliances with an adaptor.' },
        { key: 'custom_test_sequences', label: 'Custom Test Sequences', tooltip: 'Allows custom tests tailored to your equipment.' },
        { key: 'battery_power', label: 'Battery Power', tooltip: 'Makes testers portable but disables Leakage Current testing.' },
        { key: 'internal_memory', label: 'Internal Memory', tooltip: 'Stores test results for upload to a PC later.' },
        { key: 'mains_supply_test', label: 'Mains Supply Test', tooltip: 'Tests outlet power quality before appliance testing.' },
        { key: 'power_measurement', label: 'Power Measurement', tooltip: 'Measures voltage and current drawn by appliances.' },
        { key: 'hard_carry_case', label: 'Hard Carry Case', tooltip: 'Supplied in a durable carry case protecting the tester from damage.' },
        { key: 'camera_flash', label: 'Camera with Flash', tooltip: 'Useful for documentation and asset management.' },
        { key: 'colour_screen', label: 'Colour Screen', tooltip: 'Provides clearer display and better visibility.' },
        { key: 'keyboard', label: 'Keyboard', tooltip: 'Enables faster on-site data entry with QWERTY layout.' },
        { key: 'printer_compatible', label: 'Tag Printer Compatible', tooltip: 'Prints detailed tags during test and tag process.' },
        { key: 'scanner_compatible', label: 'Scanner Compatible', tooltip: 'Brings up asset info quickly via barcode scan.' },
        { key: 'PC_connectivity', label: 'PC Connectivity', tooltip: 'Connects to PC software for real-time testing/logging.' },
        { key: 'bluetooth', label: 'Bluetooth', tooltip: 'Wireless connection to compatible devices.' }
      ];

      const products = [];

      for (const item of compareList) {
        const handle = typeof item === 'string' ? item : item.handle;

        const query = `
          {
            productByHandle(handle: "${handle}") {
              title
              handle
              tags
              variants(first: 1) {
                edges {
                  node {
                    price {
                      amount
                    }
                  }
                }
              }
            }
          }
        `;

        const response = await fetch('https://pat-au.myshopify.com/api/2023-10/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': 'dae22432964103cfe12de34427a70ddc'
          },
          body: JSON.stringify({ query })
        });

        const json = await response.json();
        const product = json?.data?.productByHandle;
        if (product) products.push(product);
      }


      if (!products.length) {
        modalContent.innerHTML = '<p>No product data returned from Shopify.</p>';
        return;
      }

      let html = `
      <div class="compare-scroll-wrapper">
        <div class="compare-table-container">
          <table class="compare-table">
            <thead>
              <tr>
                <th></th>`;

      products.forEach(p => {
        html += `
                <th>
                  ${p.title}
                  <button class="remove-compare-btn" data-handle="${p.handle}" title="Remove from Compare">&times;</button>
                </th>`;
      });

      html += `
              </tr>
            </thead>
            <tr class="price-row">
              <td><strong>Price</strong></td>`;
          products.forEach(p => {
            let price = p.variants?.edges?.[0]?.node?.price?.amount;
            price = price ? `$${parseFloat(price).toFixed(2)}` : 'N/A';
            html += `<td style="text-align: center; font-weight: 600;">${price}</td>`;
          });
          `</tr>;
        <tbody>`;

      features.forEach((feature, i) => {
        html += `<tr${i % 2 ? ' class="alt-row"' : ''}>
          <td>
            <div class="feature-wrapper">
              <span class="feature-label mobile-tooltip-trigger" data-tooltip="${feature.tooltip}">
                ${feature.label}
              </span>
              <span class="tooltip-icon desktop-only">
                <i class="fas fa-info-circle"></i>
                <span class="feature-tooltip">${feature.tooltip}</span>
              </span>
            </div>
          </td>`;

        products.forEach(p => {
          const value = p.tags.includes(`compare_${feature.key}`);
          html += `<td style="text-align: center;">
            <img src="${value ? yesIcon : noIcon}" alt="${value ? 'Yes' : 'No'}" />
          </td>`;
        });

        html += `</tr>`;
      });

      html += `
            </tbody>
          </table>
        </div>
      </div>`;

      modalContent.innerHTML = html;

      document.querySelector('.compare-modal__close')?.addEventListener('click', () => {
        document.getElementById('compare-modal').style.display = 'none';
      });

      // Scroll to start
      document.querySelector('.compare-scroll-wrapper')?.scrollTo({ left: 0 });

      // Handle mobile tooltip tap
      document.querySelectorAll('.feature-label').forEach(label => {
        label.addEventListener('click', () => {
          if (window.innerWidth > 768) return;
          alert(label.dataset.tooltip);
        });
      });

      // Handle remove buttons
      document.querySelectorAll('.remove-compare-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const handle = e.target.dataset.handle;
          const newList = getCompareList().filter(p => p.handle !== handle);
          saveCompareList(newList);
      
          // Uncheck corresponding checkboxes
          document.querySelectorAll(`.compare-checkbox[data-handle="${handle}"]`).forEach(cb => {
            cb.checked = false;
          });
      
          updateCompareButtonVisibility();
          loadCompareBar();
      
          if (newList.length === 0) {
            closeCompareModal();
          } else {
            openCompareModal();
          }
        });
      });


    } catch (err) {
      console.error('Compare fetch error:', err);
      modalContent.innerHTML = '<p>There was a problem loading comparison data.</p>';
    }
  };

  window.closeCompareModal = function () {
    document.getElementById('compare-modal').style.display = 'none';
  };

  const compareBar = document.getElementById('compare-bar');
  const stickyAtc = document.getElementById('sticky-atc-bar');
  
  if (compareBar && stickyAtc) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Sticky ATC is visible — move compare bar up
            compareBar.style.bottom = `${stickyAtc.offsetHeight}px`;
          } else {
            // Sticky ATC is not visible — stick to bottom
            compareBar.style.bottom = '0';
          }
        });
      },
      {
        root: null,
        threshold: 0,
      }
    );
  
    observer.observe(stickyAtc);
  }

  // --- Close modal on outside click ---
  function attachOutsideClickToModal() {
    const modal = document.getElementById('compare-modal');

    if (!modal) return;

    // Attach a one-time listener to the backdrop only
    modal.addEventListener('click', function onClick(event) {
      if (event.target === modal) {
        closeCompareModal();
      }
    }, { once: true });
  }




